import React from 'react';
import localization from '../helpers/localization.js';
import { contentRoot } from '../config.js';

const StoveSelectionComponent = ({ stoveChanged, stoves, selectedStove, showPrices, prices, stoveDescription, showDescription,showRemoveStoveBtn, descriptionChanged }) =>
  {
    const carouselStoves = stoves.filter(stove => stove.image);
    const selectedIndex = Math.max(0, carouselStoves.findIndex(stove => stove.id === selectedStove));
    const previousIndex = (selectedIndex - 1 + carouselStoves.length) % carouselStoves.length;
    const nextIndex = (selectedIndex + 1) % carouselStoves.length;
    const visibleStoves = [carouselStoves[previousIndex], carouselStoves[selectedIndex], carouselStoves[nextIndex]];
    const selected = carouselStoves[selectedIndex];
    return (<div className="stoveCarousel">
        <h2>{localization.stove}</h2>
        <div className="stoveCarouselTrack">
          <button type="button" className="carouselArrow" onClick={() => stoveChanged(carouselStoves[previousIndex])} aria-label="Edellinen kiuas">‹</button>
          {visibleStoves.map((stove, index) => <button type="button" key={stove.id} className={"stoveCard " + (index === 1 ? "isSelected" : "sideCard")} onClick={() => stoveChanged(stove)}>
            <img src={contentRoot + stove.image} alt={stove.name} />
            {index === 1 && <span className="selectionCheck">✓</span>}
          </button>)}
          <button type="button" className="carouselArrow" onClick={() => stoveChanged(carouselStoves[nextIndex])} aria-label="Seuraava kiuas">›</button>
        </div>
        <div className="stoveDetails"><strong>{selected.name}</strong><span>{selected.power}</span><span>Suositeltu tilavuus {selected.recommendedSaunaSize}</span>{showPrices && prices && <span>{prices[selected.id]} €</span>}</div>
        {removeStoveBtn(showRemoveStoveBtn, stoveChanged)}
        {descriptionControl(showDescription, stoveDescription, descriptionChanged)}
        </div>)
  }
export default StoveSelectionComponent


let descriptionControl = (showDescription, stoveDescription,descriptionChanged) => {
    if (showDescription) {
        return < div><label htmlFor="stoveDescription"  >Kiukaan merkki/malli</label><input type="text" onChange={(event) => descriptionChanged(event.target.value)} value={stoveDescription} id="stoveDescription"></input></div >
    }
    else {
        return "";
    }
}
let removeStoveBtn = (showRemoveStoveBtn, stoveChanged) => {
    if (showRemoveStoveBtn) {
        return <button type="button" className="textAction" onClick={() => stoveChanged("ownStove")}>Ei kiuasta / hankin kiukaan itse</button>
    }
    else
        return "";

}
